import React, { useRef } from 'react';

import { routeEmailToItsPortal } from 'utils/loginRouter';

/**
 * Wires the email field of a sign-in surface to the identity router (PHX-1295, design §3.6).
 *
 * `destinationPath` is where the other environment should land the user: its login page from the
 * login form, its forgot-password page from forgot-password. Without the second one a provider who
 * clicks "Forgot password" before their address has resolved sends the reset to the wrong
 * environment, where it correctly finds nobody and nothing happens.
 *
 * Blur fires on every tab-out, so the same address is only ever resolved once: re-blurring a field
 * nobody edited must not put another request in front of the login form.
 */
const useLoginRouter = (destinationPath: string) => {
  const resolved = useRef<string | null>(null);

  const onEmailBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const email = event.target.value.trim();
    if (!email || email === resolved.current) {
      return;
    }
    resolved.current = email;
    routeEmailToItsPortal(email, destinationPath);
  };

  return { onEmailBlur };
};

export default useLoginRouter;
